import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import neaLogo from '../../assets/high_quality_logo/nea_white.png';

const FooterWrapper = styled.footer`
  background: #000;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  padding: 3rem 2rem;
  width: 100%;
  position: relative;
  z-index: 10;
  
  @media (max-width: 768px) {
    padding: 2rem 1rem;
  }
`;

const FooterInner = styled.div`
  max-width: 1200px;
  margin: 0 auto;
`;

const FooterGrid = styled.div`
  display: grid;
  grid-template-columns: 2fr 1fr 1fr 1fr;
  gap: 3rem;
  margin-bottom: 2rem;
  
  @media (max-width: 768px) {
    grid-template-columns: 1fr 1fr;
    gap: 2rem;
  }
  
  @media (max-width: 480px) {
    grid-template-columns: 1fr;
    gap: 1.5rem;
  }
`;

const FooterSection = styled.div``;

const FooterTitle = styled.h4`
  color: #fff;
  font-size: 0.85rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 1rem;
`;

const LogoImg = styled.img.attrs({ alt: 'Néa' })`
  height: 0.7em;
  width: auto;
  vertical-align: middle;
  display: inline-block;
  margin: 0 0.08em;
  margin-bottom: 0.11em;
`;

const FooterDescription = styled.p`
  color: rgba(255, 255, 255, 0.6);
  font-size: 0.9rem;
  line-height: 1.6;
  margin-bottom: 1rem;
`;

const FooterLinks = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
`;

const FooterLinkItem = styled.li`
  margin-bottom: 0.5rem;
`;

const FooterLink = styled(Link)`
  color: rgba(255, 255, 255, 0.6);
  text-decoration: none;
  font-size: 0.9rem;
  transition: color 0.2s ease;
  
  &:hover {
    color: #fff;
  }
`;

const FooterExternalLink = styled.a`
  color: rgba(255, 255, 255, 0.6);
  text-decoration: none;
  font-size: 0.9rem;
  transition: color 0.2s ease;
  
  &:hover {
    color: #fff;
  }
`;

const FooterBottom = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-top: 2rem;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  
  @media (max-width: 768px) {
    flex-direction: column;
    gap: 1rem;
    text-align: center;
  }
`;

const Copyright = styled.p`
  color: rgba(255, 255, 255, 0.5);
  font-size: 0.85rem;
`;

const Footer = () => {
  return (
    <FooterWrapper>
      <FooterInner>
        <FooterGrid>
          <FooterSection>
            <FooterTitle><LogoImg src={neaLogo} /></FooterTitle>
            <FooterDescription>
              L'intelligence artificielle au service de ta liberté financière. 
              Gère ton argent simplement, avec un copilote qui te comprend.
            </FooterDescription>
          </FooterSection>
          
          <FooterSection>
            <FooterTitle>Navigation</FooterTitle>
            <FooterLinks>
              <FooterLinkItem>
                <FooterLink to="/">Accueil</FooterLink>
              </FooterLinkItem>
              <FooterLinkItem>
                <FooterLink to="/about">À propos</FooterLink>
              </FooterLinkItem>
              <FooterLinkItem>
                <FooterLink to="/support">Support</FooterLink>
              </FooterLinkItem>
            </FooterLinks>
          </FooterSection>
          
          <FooterSection>
            <FooterTitle>Légal</FooterTitle>
            <FooterLinks>
              <FooterLinkItem>
                <FooterLink to="/privacy">Confidentialité</FooterLink>
              </FooterLinkItem>
              <FooterLinkItem>
                <FooterLink to="/privacy#cookies">Cookies</FooterLink>
              </FooterLinkItem>
            </FooterLinks>
          </FooterSection>
          
          <FooterSection>
            <FooterTitle>Contact</FooterTitle>
            <FooterLinks>
              <FooterLinkItem>
                <FooterExternalLink href="mailto:support@nea.lu">
                  support@nea.lu
                </FooterExternalLink>
              </FooterLinkItem>
              <FooterLinkItem>
                <FooterExternalLink href="mailto:info@nea.lu">
                  info@nea.lu
                </FooterExternalLink>
              </FooterLinkItem>
            </FooterLinks>
          </FooterSection>
        </FooterGrid>
        
        <FooterBottom>
          <Copyright>© {new Date().getFullYear()} Nea. Tous droits réservés.</Copyright>
        </FooterBottom>
      </FooterInner>
    </FooterWrapper>
  );
};

export default Footer;
